export const tableStyles = {
  offersListHeaderStyles: {
    tableStyle: {
      'font-size': '1.3rem',
      'border-collapse': 'collapse',
      'width': '100%',
      'position': 'relative'
    },
    tdStyle: {
      'font-weight': 'normal',
      'padding': '1rem 1rem',
      'background-color': 'rgb(246,246,230)'
    },
    trStyle: {
      'border': '1px solid #cecece'
    }
  },
  offersListDataStyle: {
    tableStyle: {
      'font-size': '1.3rem',
      'border-collapse': 'collapse',
      'width': '100%'
    },
    tdStyle: {
      'font-weight': 'normal',
      'padding': '1rem 1rem',
      'background-color': 'transparent'
    },
    trStyle: {
      'border': '1px solid #cecece',
      'background-color': 'transparent'
    },
    aStyle: {
      'cursor': 'pointer'
    },
    aActualStyle: {
      'cursor': 'pointer',
      'color': 'black'
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/selected-offers-list/tableStyles.js